// 瀑布流列表 載入畫面
import '../../styles/skelton.scss';

const SkeltonComponent = () => {
    return (
        <div className="rounded-[10px] overflow-hidden group border-1 border-black1 mb-[8px]">
            <div className="w-full aspect-[1] skelton" />
            <div className="px-[16px] pt-[12px]">
                <div className="h-[22px] w-full skelton" />
                <div className="my-[22px] h-[20px] w-full skelton" />
            </div>
        </div>
    );
};

const MasonrySkelton = ({ type = 'index' }) => {
    const containerMap = {
        search: 'ulg:px-[30px] umd:!px-[15px]',
        index: 'px-[107px] uxxl:px-[30px] ulg:!px-[15px]',
        topic: 'ulg:px-[30px] umd:!px-[15px]',
        user: 'ulg:px-[30px] umd:!px-[15px]',
    };

    const columnMap = {
        search: 'columns-4 uxl:columns-3 umd:!columns-2',
        index: 'columns-5 bxxl:columns-4 bxl:columns-3 blb:columns-3 blg:columns-3 umd:!columns-2',
        topic: 'columns-4 uxl:columns-3 umd:!columns-2',
        user: 'columns-3 umd:columns-2',
    };

    return (
        <section className={`w-full mx-auto ${containerMap?.[type]}`}>
            <div className={`gap-x-[4px] gap-y-[8px] ${columnMap?.[type]}`}>
                {new Array(20).fill(0).map((_, i) => (
                    <SkeltonComponent key={'skelton' + i + type} />
                ))}
            </div>
        </section>
    );
};

export default MasonrySkelton;
